import { Link } from 'react-router'

const NotFound = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
      <div className="card">
        <div className="card-body">
          <h1 className="display-4">404</h1>
          <p className="lead">Oops! The page you are looking for does not exist.</p>
          <Link to="/" className="btn btn-primary mt-3">
            Go Back
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound
